export default "__VITE_ASSET__cfe12dce__"